const INACTIVITY_MONTH_THRESHOLD = 2;

export function isLastLoginStale(lastLoginDate, thresholdMonths = INACTIVITY_MONTH_THRESHOLD) {
  if (!lastLoginDate) {
    return false;
  }

  const lastLogin = new Date(lastLoginDate);
  if (isNaN(lastLogin.getTime())) {
    return false;
  }

  const thresholdDate = new Date();
  thresholdDate.setMonth(thresholdDate.getMonth() - thresholdMonths);

  return lastLogin < thresholdDate;
}

export function hasStaleLogin(user) {
  return !!(user && isLastLoginStale(user.last_logged_in_at));
}

export {INACTIVITY_MONTH_THRESHOLD};



/** WEBPACK FOOTER **
 ** ./src/components/admin/users/userStatus.util.js
 **/